import { Center, Divider as DividerBase } from '@chakra-ui/layout';

export function Divider() {
  return (
    <Center height="50px">
      <DividerBase orientation="vertical" colorScheme="gray" opacity="0.3" />
    </Center>
  );
}
